import React, { Fragment } from 'react';

export const About = () => {
  return (
    <Fragment>
      <h1>About This App!</h1>
      <p>Use this App to search for campsites in the West</p>
    </Fragment>
  );
};

export default About;
